import {
  CanSendAntragPipe,
  CurrentBelegSizePipe,
  CurrentSizeInBytePipe,
  HasAllMandatoryPagesPipe,
  HasPagesPipe,
  MaxSizeExceededPipe,
  PercentageOfMaxSizePipe,
} from './pipes';
import { EbeihilfeEinreichungComponent } from './components';
import { EinreichungDirective } from './directives';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HeaderBeihilfeLegacyInterceptor } from '@ebeihilfe/core';
import { NgModule } from '@angular/core';

const PIPES = [
  MaxSizeExceededPipe,
  CurrentSizeInBytePipe,
  CanSendAntragPipe,
  CurrentBelegSizePipe,
  HasPagesPipe,
  PercentageOfMaxSizePipe,
  HasAllMandatoryPagesPipe,
];

@NgModule({
  declarations: [EbeihilfeEinreichungComponent],
  imports: [...PIPES, EinreichungDirective],
  exports: [EbeihilfeEinreichungComponent, ...PIPES],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderBeihilfeLegacyInterceptor,
      multi: true,
    },
  ],
})
export class OldCoreEinreichungModule {}
